import SpinnerOverlay from "src/components/common/SpinnerOverlay";
import PDAHeader from "src/components/common/Header";
import usePDA1110_R01Store from "./usePDA1110_R01Store";
import { usePDAContainer } from "src/hooks/usePDAContainer";
import PDA1110_R01Content from "./PDA1110_R01Content";
import PDA1110_R01Info from "./PDA1110_R01Info";

interface PDA1110_R01ContainerProps {
  menuNm: string;
  menuCd?: string;
  onBack?: () => void;
}

const PDA1110_R01Container = ({ menuNm, menuCd, onBack }: PDA1110_R01ContainerProps) => {
  // Store에서 로딩 상태 가져오기
  const { loading, reset } = usePDA1110_R01Store();
  
  // 공통 PDA 컨테이너 로직 (Reset 등록, 메뉴 클릭 핸들러)
  const { handleMenuClick } = usePDAContainer(reset);
  
  // 비즈니스 로직
  const { handleBarcodeScan, handleSave } = PDA1110_R01Content();

  return (
    <div className="w-full h-screen flex flex-col bg-white fixed inset-0">
      {/* 헤더 */}
      <PDAHeader menuNm={menuNm} menuCd={menuCd} onBack={onBack} onMenuClick={handleMenuClick} />

      {/* 메인 컨텐츠 */}
      <div className="flex-1 overflow-hidden">
        <div className="h-full flex flex-col overflow-hidden">
          {/* 바코드 등록 폼 */}
          <PDA1110_R01Info onBarcodeScan={handleBarcodeScan} onSave={handleSave} />
        </div>
      </div>

      {loading && <SpinnerOverlay text="처리 중입니다..." />}
    </div>
  );
};

export default PDA1110_R01Container;
